import React, { PureComponent } from 'react';
import { node } from 'prop-types';
import { listingDataShape } from 'shapes';
import { withListingData } from 'connectors';
import { Provider } from './ListingTypeContext';

import {
    BrandPage,
    CategoryPage,
    PrivateSalePage,
    SearchPage,
} from './components';

class ListingType extends PureComponent {
    static propTypes = {
        children: node.isRequired,
        listingData: listingDataShape.isRequired,
    };

    static getCurrentTypeInfos(listingData) {
        /* eslint-disable indent */ // it's for switch
        switch (listingData.type) {
            case 'category':
                return {
                    category: {
                        context: listingData.params.context,
                        level: `l${listingData.params.level}`,
                        id: listingData.params.id,
                        name: listingData.params.name,
                    },
                    promotedProduct: listingData.promotedProduct,
                };
            case 'brand':
                return {
                    brand: listingData.params,
                };
            case 'vp':
                return {
                    vp: listingData.params,
                };
            case 'search':
                return {
                    search: listingData.params,
                    inCategorySearch:
                        listingData.params?.context?.inCategorySearch,
                };
            default:
                break;
        }
        /* eslint-enable indent */
        return {};
    }

    constructor(props) {
        super(props);
        this.state = {};
        if (props.listingData) {
            this.state = {
                ...ListingType.getCurrentTypeInfos(props.listingData),
                listingData: props.listingData,
            };
        }
    }

    updateListingData = newListingData => {
        this.setState({
            listingData: newListingData,
            ...ListingType.getCurrentTypeInfos(newListingData),
        });
    };

    render() {
        const { children } = this.props;
        const {
            brand,
            search,
            vp,
            category,
            promotedProduct,
            listingData,
            inCategorySearch,
        } = this.state;

        return (
            <Provider
                value={{
                    state: {
                        brand,
                        vp,
                        search,
                        listingType: listingData.type,
                        promotedProduct,
                    },
                    actions: {
                        updateListingData: this.updateListingData,
                    },
                }}
            >
                {listingData.type === 'brand' && (
                    <BrandPage value={brand}>{children}</BrandPage>
                )}

                {listingData.type === 'vp' && (
                    <PrivateSalePage sale={vp}>{children}</PrivateSalePage>
                )}

                {listingData.type === 'search' && (
                    <SearchPage categoryPreviews={inCategorySearch}>
                        {children}
                    </SearchPage>
                )}

                {listingData.type === 'category' && (
                    <CategoryPage value={category}>{children}</CategoryPage>
                )}
            </Provider>
        );
    }
}

export default withListingData(ListingType);
